import React, { Fragment } from 'react';
import { object } from 'prop-types';
import * as R from 'ramda';

import {
  StatusWrapper,
  ClientFullName,
  ClientFeedback,
} from './styles';

import { theme } from '../../../../../../styles';
import { SvgIcon } from '../../../../../svg-icon';
import { RatePannel } from '../../../../../rate-pannel';
import { ReactQuillWrapped } from '../../../../../react-quill';


export function Feedback({
  contact,
  feedback,
}) {
  const {
    _id,
    text,
    rate,
    clientReceivedEmailWithFeedback = null,
    clientReceivedEmailWithMeetingNoteAndFeedback = null,
    reasonOfFail = null,
  } = feedback;

  return (
    <div key={_id}>
      <ClientFullName>{contact.fullName}</ClientFullName>
      {text && <ReactQuillWrapped value={text} readOnly />}
      {
        rate
          ? <RatePannel rateValue={rate} withoutPadding />
          : <ClientFeedback>No Feedback</ClientFeedback>
      }
      {!R.isNil(clientReceivedEmailWithMeetingNoteAndFeedback) && (
        <StatusWrapper>
          {clientReceivedEmailWithMeetingNoteAndFeedback ? (
            <Fragment>
              <SvgIcon type="checkInCircle" color={theme.colors.green} /><span>Email (Feedback & Meeting Note) sent to client {reasonOfFail && `${reasonOfFail}`}</span>
            </Fragment>
          ) : (
            <Fragment>
              <SvgIcon type="crossInCircle" color={theme.colors.vividRed} /><span>Email (Feedback & Meeting Note) wasn`t sent to client {reasonOfFail && `${reasonOfFail}`}</span>
            </Fragment>
          )}
        </StatusWrapper>
      )}

      {!R.isNil(clientReceivedEmailWithFeedback) && (
        <StatusWrapper>
          {clientReceivedEmailWithFeedback ? (
            <Fragment>
              <SvgIcon type="checkInCircle" color={theme.colors.green} /><span>Email (Feedback) sent to client</span>
            </Fragment>
          ) : (
            <Fragment>
              <SvgIcon type="crossInCircle" color={theme.colors.vividRed} /><span>Email (Feedback) wasn`t sent to client</span>
            </Fragment>
          )}
        </StatusWrapper>
      )}
    </div>
  );
}

Feedback.propTypes = {
  contact: object.isRequired,
  feedback: object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/feedbacks/feedback/index.js